import { Link } from "react-router-dom";
import "../styles/pages/project.scss";

export default function Mooz() {
  return (
    <div className="project-page">
      <img src={require("../assets/mooz.png")} alt="Mooz" />
      <div className="main-content">
        <div>
          <h1 className="title">Mooz</h1>
          <div className="caption">
            Video interview platform for job-seekers looking to elevate their
            communication skills.
          </div>
        </div>
        <div className="links">
          <div>
            <a
              className="highlight-2"
              href="https://moozvideointerview.netlify.app/"
              target="blank"
              tabindex="0"
            >
              <span>Visit Mooz</span>
            </a>
          </div>
        </div>
        <div className="body">
          <h2 className="heading">Background</h2>
          <p>
            The purpose of this project was to develop an advanced video
            interview platform that mimics authentic interview conditions. The
            primary goal was to help users enhance their interview skills by
            selecting from a range of questions, recording their responses, and
            reviewing their performance. This comprehensive approach aims to
            build users' confidence and skills, ultimately enhancing their
            performance in actual job interviews. The platform employs secure,
            multi-layered user authentication, ensuring the safety of users'
            data, as well as various tools such as an AI assistant, which
            provides personalised career feedback and guidance.
            <br />
            <br />
            <bold>My specific role on the project</bold>
            <br />
            As a software engineer, I was responsible for implementing the
            entire lifecycle of the project. This involved gathering and
            analysing requirements, designing the system architecture, and
            developing core functionalities. I integrated multi-layered user
            authentication protocols to ensure data security and privacy.
            Additionally, I designed and implemented the user interface for an
            intuitive experience. I conducted thorough testing, deployed the
            platform, and provided ongoing maintenance and updates to ensure its
            robustness and effectiveness.
          </p>
        </div>
        <br />
        <p className="page-disclaimer">
          This section is currently being updated. Please check back soon for
          the full content. In the meantime, feel free to browse through my
          other projects <a href="/">here</a>.
        </p>
        <br />
        <a href="/#projects" className="highlight-2">
          Back to projects
        </a>
      </div>
    </div>
  );
}
